import React from 'react';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';

function Internationalization({ children }) {
  return <ConfigProvider locale={ptBR}>{children}</ConfigProvider>;
}

export default Internationalization;
